import React, { useState } from 'react';
import { Quote } from 'lucide-react';

interface TestimonialCardProps {
  text: string;
  author: string;
  role: string;
  avatar: string;
  gradient: string;
  delay: number;
}

const TestimonialCard: React.FC<TestimonialCardProps> = ({
  text,
  author,
  role,
  avatar,
  gradient,
  delay
}) => {
  const [isHovered, setIsHovered] = useState(false);

  return (
    <div
      className={`group relative bg-slate-800/50 backdrop-blur-xl border border-slate-700/50 rounded-2xl p-8 hover:border-indigo-500/50 transition-all duration-500 cursor-pointer ${
        isHovered ? 'transform -translate-y-2 shadow-2xl' : 'shadow-lg'
      }`}
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
      style={{ animationDelay: `${delay}ms` }}
    >
      {/* Quote icon */}
      <div className="absolute -top-4 left-8">
        <div className={`w-8 h-8 bg-gradient-to-br ${gradient} rounded-full flex items-center justify-center shadow-lg`}>
          <Quote className="w-4 h-4 text-white" />
        </div>
      </div>
      
      {/* Background gradient effect */}
      <div className={`absolute inset-0 bg-gradient-to-br ${gradient} opacity-0 group-hover:opacity-5 rounded-2xl transition-opacity duration-500`}></div>
      
      {/* Testimonial text */}
      <div className="relative">
        <p className="text-slate-200 leading-relaxed mb-6 italic">
          "{text}"
        </p>
        
        {/* Author info */}
        <div className="flex items-center">
          <div className={`w-12 h-12 bg-gradient-to-br ${gradient} rounded-full flex items-center justify-center text-white font-bold mr-4 shadow-lg group-hover:scale-110 transition-transform duration-300`}>
            {avatar}
          </div>
          <div>
            <h4 className="text-white font-semibold">
              {author}
            </h4>
            <p className="text-slate-400 text-sm">
              {role}
            </p>
          </div>
        </div>
      </div>
      
      {/* Rating stars */}
      <div className="flex mt-4 space-x-1">
        {[1, 2, 3, 4, 5].map((star) => (
          <div key={star} className="w-4 h-4 text-yellow-400">
            ⭐
          </div>
        ))}
      </div>
    </div>
  );
};

export default TestimonialCard;